import { render } from "./odn-form-field-container.vue?vue&type=template&id=2f39c904"
import script from "./odn-form-field-container.vue?vue&type=script&lang=js"
export * from "./odn-form-field-container.vue?vue&type=script&lang=js"

import "./odn-form-field-container.vue?vue&type=style&index=0&id=2f39c904&lang=scss"

import exportComponent from "/oudini/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__